






import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Chart} from 'highcharts-vue';
import More from 'highcharts/highcharts-more';
import Highcharts from 'highcharts';
import {colors} from '@/config';
import vue from 'vue';
import {
  CHART_WIDTH_BASELINE,
  applySlideWaterfallChartSizing,
  scaleChartPx,
  waterfallTickPixelInterval,
} from '@/utils/chartPresentationSizing';

More(Highcharts);

@Component({components: {Chart}})
export default class CashflowV2 extends Vue {
  @Prop() readonly cashflow!: any;
  @Prop() readonly balance!: any;
  @Prop() dark!: boolean;
  @Prop() containerWidth: any;
  @Prop() currentLanguage: any;


  chartOptions: any = {};

  update() {
    const cw =
      this.containerWidth > 0 ? this.containerWidth : CHART_WIDTH_BASELINE;

    this.chartOptions = {
    chart: {
      type: 'waterfall',
      backgroundColor: 'transparent',
    },
    credits: {
      enabled: false,
    },

    title: {
      text: '',
    },

    yAxis: {
      title: {
        text: '',
      },
      labels: {
        style: {
          fontSize: '1cqw',
          color: this.dark ? colors.White : colors.DarkGrey,
        },
        formatter() {
          return (vue as any).options.filters.KR((this as any).value);
        },
      },

      plotLines: [{
        color: colors.Black,
        width: this.transformPx(2),
        value: 0,
        zIndex: 2,
      }],

      tickPixelInterval: waterfallTickPixelInterval(cw, 150, 48),
      gridLineColor: this.dark ? colors.Black : colors.LightGrey,
    },

    xAxis: {
      type: 'category',
      labels: {
        autoRotation: [0],
        staggerLines: 1,
        padding: scaleChartPx(10, cw),
        style: {
          fontSize: '1cqw',
          color: this.dark ? colors.White : colors.Black,
          textOverflow: 'none',
          whiteSpace: 'normal',
        },
      },
      lineColor: this.dark ? colors.Black : colors.LightGrey,
      plotLines: [{
          color: this.dark ? colors.Primary : colors.Light,
          value: 6.5,
          width: this.transformPx(2),
          zIndex: 2,

          label: {
            text: 'analyscenter.se',
            verticalAlign: 'bottom',
            textAlign: 'right',
            y: this.transformPx(-10),
            style: {
              fontSize: '0.875cqw',
              color: colors.LightGrey,
            },
          },
        },

        {
          color: this.dark ? colors.Primary : colors.Light,
          value: 0.5,
          width: this.transformPx(1),
        },
        {
          color: this.dark ? colors.Primary : colors.Light,
          value: 5.5,
          width: this.transformPx(1),
        },
      ],
      plotBands: [{
        color: this.dark ? colors.Primary : colors.Light,
        from: -0.5,
        to: 0.5,
      },
        {
          color: this.dark ? colors.Primary : colors.Light,
          from: 5.5,
          to: 6.5,
        },
      ],
    },

    plotOptions: {
      series: {
        borderColor: colors.Black,
        lineColor: this.dark ? colors.White : colors.Black,
        lineWidth: this.transformPx(2),
        dashStyle: 'ShortDash',
      },
    },


    legend: {
      enabled: false,
    },

    tooltip: {
      headerFormat: '',
      formatter() {
        const me = this as any;
        const v = (vue as any).options.filters.TKR(me.point.y);
        const z = (vue as any).options.filters.TKR(me.point.y - me.point.JPrev);
        const x = (vue as any).options.filters.TKR(me.point.J);
        if (me.key === Vue.prototype.$t('UB')) {
          return `${me.point.subname}: <b>${v}</b><br/>${Vue.prototype.$t('Årets kassaflöde')}: <b>${z}</b>`;
        } else {
          return `${me.point.subname}: <b>${v}</b>`;
        }
      },
      // pointFormat: '{point.subname}:  <b>{point.y:,.0f} tkr</b>',
      style: {
        fontSize: '1.25cqw',
        color: this.dark ? colors.White : colors.Black,
      },
      backgroundColor: this.dark ? colors.Dark : colors.Light,
    },

    series: this.getSeries(),
  };

    applySlideWaterfallChartSizing(this.chartOptions, cw, 20);

    this.$nextTick(() => {
      const chart = this.$refs.chart as any;
      if (chart && chart.chart) {
        chart.chart.reflow();
      }
    });
  }

  mounted() {
    this.update();
  }

  @Watch('balance', {immediate: false, deep: true})
  onBalanceChanged() {
    this.update();
  }

  @Watch('cashflow', {immediate: false, deep: true})
  onCashflowChanged() {
    this.update();
  }

  @Watch('containerWidth')
  containerWidthChanged() {
    this.update();
  }

    getSeries() {
    if (this.cashflow === undefined) {
      return [];
    }
    if (this.cashflow.sheets === undefined) {
      return [];
    }
    if (this.cashflow.sheets.length === 0) {
      return [];
    }
    if (this.balance === undefined) {
      return [];
    }
    if (this.balance.sheets === undefined) {
      return [];
    }
    if (this.balance.sheets.length === 0) {
      return [];
    }

    const cf = this.cashflow.sheets[0];
    const br = this.balance.sheets[0];
    const brPrev = this.balance.sheets[1] || br;
    return [{
      upColor: colors.Positive,
      color: colors.Negative,
      data: [{
        name: this.currentLanguage === 'en' ? 'Incoming Cash' : Vue.prototype.$t('IB'),
        subname: this.currentLanguage === 'en' ? 'Incoming balance Cash' : Vue.prototype.$t('IB Kassa & Bank'),
        color: this.dark ? colors.Dark : colors.LightGrey,
        y: brPrev.J, // Värdet kommer från BR "Kassa & Bank" föregående år
      },
        {
          name: this.currentLanguage === 'en' ? 'Operating cashflow' : Vue.prototype.$t('Operativt kassaflöde'),
          subname: this.currentLanguage === 'en' ? 'Operating cashflow' : Vue.prototype.$t('Operativt kassaflöde'),
          y: cf.OperatingCashflow,
        },
        {
          // tslint:disable:max-line-length
          name: this.currentLanguage === 'en' ? 'Change Working capital' : Vue.prototype.$t('Förändring rörelsekapital'),
          subname: this.currentLanguage === 'en' ? 'Change Working capital' : Vue.prototype.$t('Förändring rörelsekapital'),
          y: cf.WorkingCaptialCashflow,
        },
        {
          name: this.currentLanguage === 'en' ? 'Investments' : Vue.prototype.$t('Investeringar'),
          subname: this.currentLanguage === 'en' ? 'Investments' : Vue.prototype.$t('Investeringar'),
          y: cf.InvestmentsCashflow,
        },
        {
          name: this.currentLanguage === 'en' ? 'Change Interest bearing liabilities' : Vue.prototype.$t('Förändring räntebärande skulder'),
          subname: this.currentLanguage === 'en' ? 'Change Interest bearing liabilities' : Vue.prototype.$t('Förändring räntebärande skulder'),
          y: cf.InterestLiabilitiesDelta,
        },
        {
          name: this.currentLanguage === 'en' ? 'Owners capital' : Vue.prototype.$t('Ägarkapital'),
          subname: this.currentLanguage === 'en' ? 'Owners capital' : Vue.prototype.$t('Ägarkapital'),
          y: cf.EquityWithoutNetProfitDelta + cf.SubscribedCapitalUnpaidDelta,
        },
        {
          name: this.currentLanguage === 'en' ? 'Outcoming Cash' : Vue.prototype.$t('UB'),
          subname: this.currentLanguage === 'en' ? 'Outgoing balance Cash' : Vue.prototype.$t('UB Kassa & Bank'),
          isSum: true, // Värdet bör vara detsamma som BR "Kassa & Bank" innevarande år
          color: this.dark ? colors.Dark : colors.LightGrey,
          JPrev: brPrev.J,
          J: br.J,
        },
      ],

      pointPadding: 0,
    }];
  }

  transformPx(value: any) {
    const cw =
      this.containerWidth > 0 ? this.containerWidth : CHART_WIDTH_BASELINE;
    return scaleChartPx(value, cw);
  }
}


